import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  SERVICE_QUERYTYPE: 1,
}, km({
  SERVICE_GETQUESTIONLIST_SUCCESS: null,
  SERVICE_GETQUESTIONLIST_ERROR: null,
  SERVICE_GETQUESTIONDETAIL_SUCCESS: null,
  SERVICE_GETQUESTIONDETAIL_ERROR: null,
}))
